import { render, staticRenderFns } from "./add-post.vue?vue&type=template&id=1c685872&"
import script from "./add-post.vue?vue&type=script&lang=js&"
export * from "./add-post.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports